export const uiVideo = {
    name: 'UI Video',
    description: '',
    displayField: 'title',
    fields: {
        title: {
            name: 'Title',
            type: 'Symbol',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: []
        },
        loop: {
            name: 'Loop',
            type: 'Boolean',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: []
        },
        autoplay: {
            name: 'Autoplay',
            type: 'Boolean',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: []
        },
        muted: {
            name: 'Muted',
            type: 'Boolean',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: []
        },
        controls: {
            name: 'Controls',
            type: 'Boolean',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: []
        },
        poster: {
            name: 'Poster',
            type: 'Link',
            linkType: 'Asset',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: [{ linkMimetypeGroup: ['image'] }]
        },
        sources: {
            name: 'Sources',
            type: 'Array',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: [],
            items: {
                type: 'Link',
                validations: [{ linkMimetypeGroup: ['video'] }],
                linkType: 'Asset'
            }
        }
    }
};
//# sourceMappingURL=uiVideo.js.map